import { cx } from '@emotion/css';
import { TextXS } from '@axafr-btc-ds/typography';
import React, { useLayoutEffect, useState, useImperativeHandle, forwardRef } from 'react';
import { ColorHex } from '@axafr-btc-ds/colors';
import { getRecommendedDirection, calculateMessageShift } from '../direction-detection';
import { getMessageStyle, getTriangleStyles } from './tooltip-message-styles';
import { useElementPosition, getElementBounds } from '@axaclient-socle-front/use-element-position';
import { tooltipContentText, tooltipMessage } from './css';
var _TooltipMessage = function (_a, ref) {
    var className = _a.className, direction = _a.direction, isOpen = _a.isOpen, content = _a.content, _b = _a.containerBounds, containerBounds = _b === void 0 ? getElementBounds(document.body) : _b, originBounds = _a.originBounds, _c = _a.verticalOffset, verticalOffset = _c === void 0 ? 0 : _c;
    var _d = useElementPosition({ hasScrollRefresh: true }), messageBounds = _d.bounds, setRef = _d.setRef;
    var _e = useState({}), messageStyle = _e[0], setMessageStyle = _e[1];
    var _f = useState({ outerTriangleStyle: {}, innerTriangleStyle: {} }), triangleStyle = _f[0], setTriangleStyle = _f[1];
    useLayoutEffect(function () {
        var messageShift = calculateMessageShift({
            containerBounds: containerBounds,
            originBounds: originBounds
        });
        var newDirection = getRecommendedDirection({
            containerBounds: containerBounds,
            messageBounds: messageBounds,
            originBounds: originBounds,
            preferredDirection: direction
        });
        setMessageStyle(getMessageStyle({
            direction: newDirection,
            originWidth: originBounds.width || 0,
            isOpen: isOpen,
            messageShift: messageShift,
            verticalOffset: verticalOffset
        }));
        setTriangleStyle(getTriangleStyles({ direction: newDirection, messageShift: messageShift, originBounds: originBounds, containerBounds: containerBounds }));
    }, [JSON.stringify(containerBounds), JSON.stringify(messageBounds), JSON.stringify(originBounds), direction, isOpen, verticalOffset]);
    useImperativeHandle(ref, function () { return messageBounds; }, [messageBounds]);
    return (React.createElement("div", { ref: setRef, style: messageStyle, className: cx(tooltipMessage, className) },
        React.createElement(TextXS, { className: tooltipContentText, color: ColorHex.dimgray }, content),
        React.createElement("div", { style: triangleStyle.outerTriangleStyle }),
        React.createElement("div", { style: triangleStyle.innerTriangleStyle })));
};
export var TooltipMessage = forwardRef(_TooltipMessage);
